import { cx } from '@vtex/admin-ui'
import { FormState, Radio, RadioGroup } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { Tag } from 'ui'
import { messages } from './messages'
import styles from './styles.css'
import { RadioDescription } from 'ui/components/Radio/RadioDescription'

const DISTRIBUTED_CONFIG = 'distributed'

type Props = {
  state: FormState
  quantity: number
  minQuantity: number
}

export function Distributed(props: Props) {
  const { state, quantity, minQuantity } = props
  const { $t, formatNumber } = useIntl()

  const mountRadioTitle = (isDistributed: boolean) => {
    const contentValue = isDistributed ? minQuantity : quantity
    if (contentValue === undefined) {
      return $t(messages.distributed.placeholder, {
        value: isDistributed,
        tag: (content) => <Tag>{content}</Tag>,
      })
    }
    return $t(messages.distributed.radio, {
      value: isDistributed,
      quantity: formatNumber(contentValue),
      tag: (content) => <Tag>{content}</Tag>,
    })
  }

  return (
    <RadioGroup
      className={cx(styles.radioGroupLabel, styles.radioWithTagDescription)}
      name={DISTRIBUTED_CONFIG}
      label={
        <div className={styles.radioGroupLabel}>
          {$t(messages.distributed.group)}
        </div>
      }
      state={state}
    >
      {[false, true].map((isDistributed) => {
        return (
          <Radio
            key={String(isDistributed)}
            label={
              <RadioDescription
                title={mountRadioTitle(isDistributed)}
                description={$t(messages.distributed.description, {
                  value: isDistributed,
                })}
              />
            }
            value={String(isDistributed)}
          />
        )
      })}
    </RadioGroup>
  )
}
